<div class="clearaccept-container">
  <app-loading-panel
    [showLoading]="loading"
    [variant]="'overlay'"
    [hideText]="true"
  ></app-loading-panel>

  <form
    id="payment-form"
    class="clearaccept-form"
    (submit)="$event.preventDefault()"
  >
    <fieldset>
      <div class="apple-pay-wrapper" *ngIf="showApplePayButton">
        <ca-apple-pay
          buttonstyle="black"
          type="pay"
          locale="en-GB"
        ></ca-apple-pay>
        <div class="apple-pay-divider">
          <span>{{ 'public.payment.orPayWithCard' | translate }}</span>
        </div>
      </div>
      <div class="form-field">
        <label for="cc_name">{{
          'public.payment.nameOnCard' | translate
        }}</label>
        <input
          type="text"
          name="name"
          id="cc_name"
          class="form-control"
          [placeholder]="'public.payment.nameOnCard' | translate"
        />
      </div>

      <div class="form-field">
        <label>{{ 'public.payment.cardNumber' | translate }}</label>
        <div class="input-wrapper">
          <div id="card-wrapper"></div>
          <div id="card-errors" class="error-message"></div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field half-width">
          <label>{{ 'public.payment.expiryDate' | translate }}</label>
          <div class="input-wrapper">
            <div id="expdate-wrapper"></div>
            <div id="expdate-errors" class="error-message"></div>
          </div>
        </div>

        <div class="form-field half-width">
          <label>{{ 'public.payment.cvv' | translate }}</label>
          <div class="input-wrapper">
            <div id="cvv-wrapper"></div>
            <div id="cvv-errors" class="error-message"></div>
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <button
          type="submit"
          id="pay"
          class="btn btn-primary"
          [disabled]="!isFormValid"
          (click)="submitPayment()"
        >
          {{ 'public.payment.payNow' | translate }}
          {{ paymentDetails?.requestJSON?.paymentFormParams?.currencySymbol
          }}{{ getAmount() }}
        </button>
      </div>
    </fieldset>
  </form>
</div>
